import {
  nrtOrderDataSchema,
  nrtOrderResponseSchema,
  type NrtOrderData,
  type NrtOrderResponse,
} from '../nrt/responses';

// The order read shape under a program-neutral name. The SAME schema objects,
// not copies: existing clients and parsers read this shape today, and a copy
// would be a second definition free to drift from the first (ADR-135).
export const orderDataSchema = nrtOrderDataSchema;
export type OrderData = NrtOrderData;
export const orderResponseSchema = nrtOrderResponseSchema;
export type OrderResponse = NrtOrderResponse;
